import { render, staticRenderFns } from "./CommissionDetails.vue?vue&type=template&id=83d60b4c"
import script from "./CommissionDetails.vue?vue&type=script&lang=js"
export * from "./CommissionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports